var _defs, _rect, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "AI and Generative AI",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a855f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ea5e9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "url(#g)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 166h120c22 0 40 18 40 40v64c0 22-18 40-40 40H258l-54 36v-36h-8c-22 0-40-18-40-40v-64c0-22 18-40 40-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 236h84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 266h64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 256h22M374 256h22M256 116v22M256 374v22"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 430,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
    fontSize: 64,
    fontWeight: 800,
    fill: "#ffffff"
  }, "\n    AI\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.32495f6e89c00b4cdf4ed77551ddc40b.svg";
export { ForwardRef as ReactComponent };